import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import {
  BusinessReportFilterProps,
  BusinessReportProps,
} from "../../types/businessReport";

export interface BusinessReportState {
  report: BusinessReportProps | null;
  appliedFilter: BusinessReportFilterProps | null;
  loading: boolean;
  error: string | null;
  requestId: string | null;
}

const initialState: BusinessReportState = {
  report: null,
  appliedFilter: null,
  loading: false,
  error: null,
  requestId: null,
};

export const fetchBusinessReport = createAsyncThunk(
  "fetchBusinessReport",
  async (req: BusinessReportFilterProps) => {
    let response: any;
    await GET(`/v1/admin/business-reports`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const businessReportSlice = createSlice({
  name: "businessReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBusinessReport.pending, (state, action) => {
      state.report = null;
      state.appliedFilter = action.meta.arg;
      state.loading = true;
      state.error = null;
      state.requestId = action.meta.requestId;
    });
    builder.addCase(fetchBusinessReport.fulfilled, (state, action: any) => {
      if (action.meta.requestId !== state.requestId) {
        return;
      }

      state.loading = false;

      if (action.payload?.data?.status === "success") {
        state.report = action.payload.data.data;
        state.error = null;
      } else {
        state.report = null;
        state.error =
          action.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchBusinessReport.rejected, (state, action: any) => {
      if (action.meta.requestId !== state.requestId) {
        return;
      }

      state.report = null;
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const getBusinessReport = (state: RootState) =>
  state.businessReport.report;
export const getBusinessReportFilter = (state: RootState) =>
  state.businessReport.appliedFilter;
export const getBusinessReportLoading = (state: RootState) =>
  state.businessReport.loading;
export const getBusinessReportError = (state: RootState) =>
  state.businessReport.error;

export default businessReportSlice.reducer;
